import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Plus, X } from "lucide-react";

export const SuppressionList = ({ suppressions, onSuppressionsChanged }) => {
  const [suppressEmail, setSuppressEmail] = useState("");

  const addSuppression = async () => {
    if (!suppressEmail.trim()) return;
    try {
      await api.post("/suppressions", { email: suppressEmail });
      toast.success("Address added to the do-not-email list.");
      setSuppressEmail("");
      onSuppressionsChanged();
    } catch (e) { toast.error(apiError(e)); }
  };

  const removeSuppression = async (email) => {
    try {
      await api.delete(`/suppressions/${encodeURIComponent(email)}`);
      onSuppressionsChanged();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <Card className="shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="font-serif text-xl">Do-not-email list</CardTitle>
        <p className="text-sm text-muted-foreground">{suppressions.length} unsubscribed address{suppressions.length === 1 ? "" : "es"}. These are never emailed.</p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-end gap-2 max-w-md">
          <div className="space-y-1.5 flex-1"><Label>Add an address manually</Label><Input type="email" value={suppressEmail} onChange={(e) => setSuppressEmail(e.target.value)} placeholder="person@example.com" data-testid="suppress-email-input" /></div>
          <Button variant="secondary" onClick={addSuppression} data-testid="add-suppression-btn"><Plus className="h-4 w-4" /></Button>
        </div>
        {suppressions.length > 0 && (
          <div className="flex flex-wrap gap-2" data-testid="suppressions-list">
            {suppressions.map((s) => (
              <span key={s.email} className="inline-flex items-center gap-2 rounded-full bg-secondary px-3 py-1.5 text-xs">
                {s.email}
                <button onClick={() => removeSuppression(s.email)} aria-label={`Allow emails to ${s.email} again`} data-testid={`remove-suppression-${s.email}`}><X className="h-3 w-3" /></button>
              </span>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
